<section class="content" style="margin-top: 0px">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb
        [title]="childLevelLabel"
        [items]="['Name']"
        [active_item]="'Details'"
      ></app-breadcrumb>
    </div>
    <app-church-welcome-widget></app-church-welcome-widget>

    <app-table
      [columns]="tableColumns"
      [data]="stations"
      [searchable]="true"
      [searchPlaceholder]="'Search ' + childLevelLabel"
      [pagination]="true"
      [pageSize]="10"
      [showDownload]="true"
      [showExcelDownload]="false"
      [showPdfDownload]="true"
      [showFilters]="true"
      (refresh)="refresh()"
      (downloadPdf)="downloadPDF()"
      (filterChange)="onFilterChange($event)"
    >
    </app-table>
  </div>
</section>
